import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { TipProvider } from "@/hooks/useTip.jsx";
import App from "./App.jsx";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import { AuthModalProvider } from "./components/AuthModal.jsx";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./hooks/useAuth.jsx";

Modal.setAppElement("#root");

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
        <TipProvider>
            <BrowserRouter>
                <AuthProvider>
                    <AuthModalProvider>
                        <App />
                    </AuthModalProvider>
                </AuthProvider>
            </BrowserRouter>
        </TipProvider>
    </React.StrictMode>
);
